import React from 'react';
import './PrivacyPolicy.css';

const TermsOfUse = () => (
  <div className="legal-page">
    <div className="container">
      <h1>Terms of Use</h1>
      <p className="legal-effective">Effective Date: February 17, 2026</p>
      <p>These Terms of Use ("Terms") govern your access to and use of the Solace Care 360 website ("Website") and any related online content or services provided by Solace Care 360 ("Company," "we," "our," or "us").</p>
      <p>By accessing or using this Website, you agree to be bound by these Terms. If you do not agree, you should not use this Website.</p>

      <h2>Informational Purpose Only</h2>
      <p>This Website is provided for general informational and business purposes only. It describes the services offered by Solace Care 360, including nurse-led care management and practice support solutions.</p>
      <p>Nothing on this Website constitutes:</p>
      <ul>
        <li>Medical advice</li>
        <li>Clinical treatment guidance</li>
        <li>Legal advice</li>
        <li>Financial or reimbursement guarantees</li>
      </ul>
      <p>All clinical care decisions remain the responsibility of licensed healthcare providers.</p>

      <h2>No Medical or Clinical Relationship</h2>
      <p>Use of this Website does not establish:</p>
      <ul>
        <li>A provider–patient relationship</li>
        <li>A nurse–patient relationship</li>
        <li>A healthcare provider relationship</li>
        <li>A business partnership</li>
      </ul>
      <p>A formal relationship is established only through a written agreement executed by authorized parties.</p>
      <p>If you are experiencing a medical emergency, call 911 or seek immediate care.</p>

      <h2>HIPAA & Protected Health Information</h2>
      <p>This Website is not intended for the submission of Protected Health Information (PHI) unless through a designated secure, encrypted platform.</p>
      <p>Users should not submit sensitive medical information through general contact forms or unsecured communications.</p>
      <p>Solace Care 360 complies with applicable federal and state regulations, including HIPAA, in connection with contracted services — but general website usage does not create HIPAA obligations.</p>

      <h2>Practice & Revenue Disclaimer</h2>
      <p>Descriptions of services, outcomes, reimbursement strategies, and compliance support are illustrative only.</p>
      <p>Solace Care 360 does not guarantee:</p>
      <ul>
        <li>Specific financial outcomes</li>
        <li>Reimbursement approvals</li>
        <li>Revenue performance</li>
        <li>Regulatory determinations</li>
      </ul>
      <p>Results vary depending on payer policies, documentation practices, and regulatory requirements.</p>

      <h2>Acceptable Use</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Use the Website for unlawful purposes</li>
        <li>Attempt unauthorized access to systems</li>
        <li>Reverse engineer any portion of the Website</li>
        <li>Upload malicious code</li>
        <li>Misrepresent your identity</li>
      </ul>
      <p>We reserve the right to restrict access if misuse occurs.</p>

      <h2>Intellectual Property</h2>
      <p>All Website content, including:</p>
      <ul>
        <li>Text</li>
        <li>Branding</li>
        <li>Logos</li>
        <li>Graphics</li>
        <li>Layout</li>
        <li>Service descriptions</li>
        <li>Program models</li>
      </ul>
      <p>are the exclusive property of Solace Care 360 and may not be reproduced, distributed, or used without written consent.</p>

      <h2>Third-Party Tools & Links</h2>
      <p>The Website may reference or link to third-party platforms, tools, or resources. We do not control and are not responsible for their content, privacy practices, or availability.</p>

      <h2>Disclaimer of Warranties</h2>
      <p>This Website is provided "as is" and "as available."</p>
      <p>We make no warranties, express or implied, regarding:</p>
      <ul>
        <li>Accuracy</li>
        <li>Completeness</li>
        <li>Availability</li>
        <li>Reliability</li>
      </ul>
      <p>We do not guarantee uninterrupted or error-free operation.</p>

      <h2>Limitation of Liability</h2>
      <p>To the fullest extent permitted by law, Solace Care 360 shall not be liable for:</p>
      <ul>
        <li>Indirect damages</li>
        <li>Consequential damages</li>
        <li>Lost profits</li>
        <li>Business interruption</li>
        <li>Data loss</li>
      </ul>
      <p>arising from use of this Website.</p>

      <h2>Indemnification</h2>
      <p>You agree to indemnify and hold harmless Solace Care 360 from claims, damages, or expenses resulting from your misuse of the Website or violation of these Terms.</p>

      <h2>Governing Law</h2>
      <p>These Terms are governed by the laws of the State of [Insert State], without regard to conflict of law principles.</p>

      <h2>Modifications</h2>
      <p>We reserve the right to update these Terms at any time. Continued use of the Website constitutes acceptance of any changes.</p>

      <h2>Contact Information</h2>
      <p>If you have any questions or concerns about these Terms, you may contact us by email at: <a href="mailto:Contact@solacecare360.com">Contact@solacecare360.com</a></p>
    </div>
  </div>
);

export default TermsOfUse;
